const problems = [
  {
    image: 'https://storage.readdy-site.link/project_files/4209c496-91bf-433d-89c1-fd9f1706b442/b7b45f16-1712-4514-9ab7-ae75a5417b68_compressed_unnamed.webp',
    caption: 'Розкиданий найм',
    title: 'Найм розкиданий між майданчиками',
    desc: 'Кандидат уже відгукнувся, але його треба знайти, передзвонити й не загубити до першого дня.',
  },
  {
    image: 'https://storage.readdy-site.link/project_files/4209c496-91bf-433d-89c1-fd9f1706b442/4dce561f-c89a-4ad1-9de5-219f577b8049_compressed_2.webp',
    caption: 'Приховані дані',
    title: 'Звіти не показують реальну картину',
    desc: 'Коли дані в таблицях, ERP і месенджерах — звіт збирається довго та вручну. HRD не бачить, де не закриваються вакансії.',
  },
  {
    image: 'https://storage.readdy-site.link/project_files/4209c496-91bf-433d-89c1-fd9f1706b442/ac9a9ea0-a15e-4471-900b-d30785288452_compressed_3.webp',
    caption: "Роз'єднані системи",
    title: 'HR і ERP працюють окремо',
    desc: 'Людину вже прийняли, але дані ще потрібно завести в системі обліку. Дублювання, помилки й приховані витрати.',
  },
];

export default function ProblemsSection() {
  return (
    <section id="problems" className="py-24 lg:py-32" style={{ backgroundColor: '#0c1527' }}>
      <div className="max-w-[1100px] mx-auto px-6 lg:px-10">

        <div className="text-center mb-16 lg:mb-20 max-w-[700px] mx-auto">
          <h2 className="font-heading font-bold text-white leading-[1.08] tracking-tight mb-5" style={{ fontSize: 'clamp(2rem, 4.5vw, 3.5rem)' }}>
            <span style={{ color: '#F96B25' }}>Коли HR не встигає,</span><br />виробництво втрачає темп
          </h2>
          <p className="text-white/40 text-lg lg:text-xl leading-relaxed">
            Незакрита вакансія — це зміна без людини, повільніший процес і додаткове навантаження на команду.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-7 lg:gap-8">
          {problems.map((p) => (
            <div
              key={p.title}
              className="flex flex-col gap-4"
            >
              <div className="aspect-[3/2] w-full rounded-[32px] overflow-hidden">
                <img
                  src={p.image}
                  alt={p.title}
                  className="w-full h-full object-cover"
                  title={p.title}
                />
              </div>
              <h3 className="font-heading font-semibold text-white text-xl lg:text-2xl leading-snug">
                {p.title}
              </h3>
              <p className="text-white/50 text-base leading-relaxed">
                {p.desc}
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}